'use client';

import { useEffect } from 'react';

import { isBrowserFn } from '~/utils/browser';

import { clearAnalyticsUser, reportEvent, setAnalyticsUser, updateAnalyticsUser } from './events';
import initGtag from './initGtag';
import { initSegment } from './initSegment';
import { initBugSnag } from './initBugSnag';
import {
  getAnonymousId,
  getStoredUser,
  setFirstTouchUTM,
  setReferralCode,
  setWebViewCookie,
} from './utils';

function initAnalytics() {
  if (isBrowserFn()) {
    const anonymousId = getAnonymousId();

    // Parse first touch UTM parameters on load and set a webview cookie (fallback if webview redirect loses the url param)
    setFirstTouchUTM();
    setReferralCode();
    setWebViewCookie();

    initBugSnag();
    initSegment(anonymousId);
    initGtag();
  }
}

const useAnalytics = () => {
  useEffect(() => {
    initAnalytics();
  }, []);
};

export default useAnalytics;
export {
  clearAnalyticsUser,
  reportEvent,
  setAnalyticsUser,
  updateAnalyticsUser,
  getAnonymousId,
  getStoredUser,
  initAnalytics,
  isBrowserFn,
};
